// Klien API — perilaku sama dengan api() v1:
// pesan error dari { error }, 401 di luar /api/auth/ = sesi berakhir, 428 = wajib ganti password sementara.

export class ApiError extends Error {
  constructor(
    message: string,
    readonly status: number,
    readonly data: unknown = null,
  ) {
    super(message);
    this.name = 'ApiError';
  }
}

type Listener = () => void;
const sessionExpired = new Set<Listener>();
const mustChangePassword = new Set<Listener>();
const subscribe = (set: Set<Listener>, fn: Listener) => {
  set.add(fn);
  return () => void set.delete(fn);
};
/** Dipanggil saat sesi berakhir (401) — App kembali ke layar login. Mengembalikan fungsi berhenti langganan. */
export const onSessionExpired = (fn: Listener) => subscribe(sessionExpired, fn);
/** Dipanggil saat server mewajibkan ganti password sementara (428). */
export const onMustChangePassword = (fn: Listener) => subscribe(mustChangePassword, fn);

export async function api<T = unknown>(method: string, url: string, body?: unknown): Promise<T> {
  const opt: RequestInit = { method, headers: {}, credentials: 'same-origin' };
  if (body !== undefined) {
    opt.headers = { 'Content-Type': 'application/json' };
    opt.body = JSON.stringify(body);
  }
  const res = await fetch(url, opt);
  let data: unknown = null;
  try {
    data = await res.json();
  } catch {
    data = null;
  }
  const msg = (data as { error?: string } | null)?.error;
  if (res.status === 401 && !url.startsWith('/api/auth/')) {
    for (const fn of sessionExpired) fn();
    throw new ApiError('Sesi berakhir, silakan login lagi.', 401, data);
  }
  if (res.status === 428) {
    for (const fn of mustChangePassword) fn();
    throw new ApiError(msg || 'Ganti password dulu.', 428, data);
  }
  if (!res.ok) throw new ApiError(msg || `Gagal (${res.status})`, res.status, data);
  return data as T;
}
